import {useScrollLock as _useScrollLock, createSharedComposable} from '@vueuse/core'

export const useScrollLock = createSharedComposable(_useScrollLock)
